import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import * as React from 'react'
import TableRow from '@mui/material/TableRow'
import PropTypes from 'prop-types'

const TableItems = (props) => {
  const { columns, rows } = props

  return (
    <Paper sx={{ overflow: 'auto', width: '100%', margin: 'auto' }}>
      <TableContainer sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.key}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  sx={{
                    ...(column.key === 'action'
                      ? {
                          position: {
                            xs: 'static',
                            md: 'sticky',
                          },
                          right: {
                            md: 0,
                          },
                          zIndex: {
                            md: 5, // HEADER PALING ATAS
                          },
                          background: {
                            md: '#fff',
                          },
                          boxShadow: {
                            md: 'inset 6px 0 6px -6px rgba(0,0,0,0.12)',
                          },
                        }
                      : {}),
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.key}>
                  {columns.map((column) => {
                    const value = row[column.key]
                    return (
                      <TableCell
                        key={column.key}
                        align={column.align}
                        sx={{
                          ...(column.key === 'action'
                            ? {
                                position: {
                                  xs: 'static',
                                  md: 'sticky',
                                },
                                right: {
                                  md: 0,
                                },
                                zIndex: {
                                  md: 5, // HEADER PALING ATAS
                                },
                                background: {
                                  md: '#fff',
                                },
                                boxShadow: {
                                  md: 'inset 6px 0 6px -6px rgba(0,0,0,0.12)',
                                },
                              }
                            : {}),
                        }}
                      >
                        {column.format && typeof value === 'number' ? column.format(value) : value}
                      </TableCell>
                    )
                  })}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}

TableItems.propTypes = {
  columns: PropTypes.any,
  rows: PropTypes.any,
}

export default TableItems
